import { render, staticRenderFns } from "./CommentsTableRowHeader.vue?vue&type=template&id=26a09770&"
import script from "./CommentsTableRowHeader.vue?vue&type=script&lang=ts&"
export * from "./CommentsTableRowHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports